module.exports = __webpack_public_path__ + "img/about-section-1.961c820b.jpg";